export const APPLICATIONS = {
  Select: "Select",
  Zodiak: "Zodiak",
  Speranto: "Speranto",
  Kojak: "Kojak",
  Tango: "Tango",
};
